import { rem } from 'polished'
import styled from 'styled-components'

import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import BookmarkLocationSingle from './BookmarkLocationSingle'
import BookmarkLocationWithStartAndEnd from './BookmarkLocationWithStartAndEnd'
import BookmarkLocationWithTypeOfExperience from './BookmarkLocationWithTypeOfExperience'

const Location = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(4)};
  align-items: center;
`

const LittleMarker = styled(LineMapMarkerIcon)`
  height: ${rem(20)};
  width: ${rem(20)};
`

interface Props {
  startLocation?: string | null
  endLocation?: string | null
  typeOfExperience?: string
  variant?: 'single' | 'start_and_end' | 'with_experience'
  showIcon?: boolean
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocation(props: Props) {
  const variant = props.variant ?? 'single'
  const showIcon = props.showIcon ?? true
  return (
    <Location>
      {showIcon && <LittleMarker />}
      {variant === 'single' && <BookmarkLocationSingle {...props} />}
      {variant === 'start_and_end' && <BookmarkLocationWithStartAndEnd {...props} />}
      {variant === 'with_experience' && <BookmarkLocationWithTypeOfExperience {...props} />}
    </Location>
  )
}
export default BookmarkLocation
